import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { Typography } from 'opensolar-ui'
import React from 'react'

type AnchorPosition = 'left' | 'top' | 'right' | 'bottom'
type DisplayMode = 'drawer' | 'dialog'

interface DockPositionSelectorProps {
  currentAnchor: AnchorPosition
  currentDisplayMode: DisplayMode
  onLayoutChange: (mode: DisplayMode, position?: AnchorPosition) => void
  disabled?: boolean
}

const DockPositionSelector: React.FC<DockPositionSelectorProps> = ({
  currentAnchor,
  currentDisplayMode,
  onLayoutChange,
  disabled = false,
}) => {
  const getButtonStyle = (position: AnchorPosition) => ({
    border: currentDisplayMode === 'drawer' && currentAnchor === position ? '2px solid #1976d2' : '1px solid #e0e0e0',
    borderRadius: 8,
    padding: '8px',
    backgroundColor: currentDisplayMode === 'drawer' && currentAnchor === position ? '#f0f7ff' : 'transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: 4,
    fontSize: 11,
    fontWeight: 500,
    color: disabled ? '#ccc' : currentDisplayMode === 'drawer' && currentAnchor === position ? '#1976d2' : '#666',
    transition: 'all 0.2s ease',
    opacity: disabled ? 0.5 : 1,
  })

  return (
    <div style={{ padding: '12px 16px' }}>
      <Typography
        variant="caption"
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#666',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          marginBottom: 8,
          display: 'block',
        }}
      >
        Chat Position
      </Typography>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: 8,
          marginTop: 8,
        }}
      >
        <button
          onClick={() => !disabled && onLayoutChange('drawer', 'left')}
          disabled={disabled}
          style={getButtonStyle('left')}
        >
          <ChevronLeftIcon style={{ fontSize: 16 }} />
          Left
        </button>
        <button
          onClick={() => !disabled && onLayoutChange('drawer', 'bottom')}
          disabled={disabled}
          style={getButtonStyle('bottom')}
        >
          <KeyboardArrowDownIcon style={{ fontSize: 16 }} />
          Bottom
        </button>
        <button
          onClick={() => !disabled && onLayoutChange('drawer', 'right')}
          disabled={disabled}
          style={getButtonStyle('right')}
        >
          <ChevronRightIcon style={{ fontSize: 16 }} />
          Right
        </button>
      </div>
    </div>
  )
}

export default DockPositionSelector
